import { challengeTypes } from 'constants.js';

import { IGetMaskedValue } from './challengeManagerMask.types';

const { EMAIL, SMS, VOICE } = challengeTypes;

/**
 * Utility function to get masked value of a Phone number
 * @param phoneNumber
 * @returns masked phone number
 */
export const getMaskedPhoneNumber = (phoneNumber: string) =>
  phoneNumber.replace(
    /\b[\dX][-. \dX]+(\d{4})\b/g,
    (match, capture) => Array(match.length - 4).join('*') + capture
  );

/**
 * Utility function to get masked value of an Email id
 * @param emailId
 * @returns masked email id
 */
export const getMaskedEmailId = (emailId: string) =>
  emailId.replace(/^(.)(.*)(.@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);

/**
 * Utility function to get masked value appropriate for the challengeType
 * @param props Props for the function
 * @param props.challengeType Type of challenge managed by the Challenge Manager
 * @param props.data Data provided to the Challenge Manager
 * @returns masked value appropriate for the challengeType
 */
const getMaskedValue: IGetMaskedValue = ({
  challengeType,
  data: { email, phoneNumber, voice }
}) => {
  switch (challengeType) {
    case SMS:
      return getMaskedPhoneNumber(phoneNumber);
    case EMAIL:
      return getMaskedEmailId(email);
    case VOICE:
      return getMaskedPhoneNumber(voice?.value as string);
    default:
      return null;
  }
};

export default getMaskedValue;
